import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { checkBrowserStatus, BrowserCompatibilityHeadbandComponent } from '@le_cedre/portal-lib';
import { environment } from '@env/environment';
import { NgIf, NgStyle } from '@angular/common';

@Component({
    selector: 'app-portal-email',
    template: `
        <portal-browser-compatibility-headband
            *ngIf="checkBrowserStatus() === 'Degraded'"
        ></portal-browser-compatibility-headband>
        <div
            class="portal-email email-background-img"
            [ngStyle]="{ 'background-image': 'url(' + commonStatic + 'img/group.webp)' }"
        >
            <div class="portal-email__header">
                <div class="logo"></div>
            </div>
            <router-outlet></router-outlet>
        </div>
    `,
    styleUrls: ['./email.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgIf, BrowserCompatibilityHeadbandComponent, NgStyle, RouterOutlet],
})
export class EmailComponent {
    commonStatic: string = environment.urls.commonStatic;
    checkBrowserStatus = checkBrowserStatus;

    constructor() {}
}
